<template>
  <div class="list_box">
    <div class="course_list">
      <template v-for="(item, index) in courseList">
        <Course :item="item" :key="index" />
      </template>
    </div>
    <div class="page_box">
      <el-pagination
        background=""
        :page-size="page_size"
        layout="prev, pager, next"
        @current-change="changePage"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Course from "@/components/Course";
import { fetchVideoList, fetchVideoListNotLogin } from "@/api/video";
import { mapState } from "vuex";
export default {
  name: "CourseList",
  props: {
    course_id: {
      type: String,
      default: "1"
    }
  },
  data() {
    return {
      page: 1,
      page_size: 15,
      total: 0,
      courseList: []
    };
  },
  computed: {
    ...mapState("user", ["has_login"])
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      const { course_id, page, has_login } = this;
      if (has_login) {
        fetchVideoList({
          type: course_id,
          page
        }).then((res) => {
          const { data } = res;
          this.total = data.total;
          this.courseList = data.data;
        });
      } else {
        fetchVideoListNotLogin({
          type: course_id,
          page
        }).then((res) => {
          const { data } = res;
          this.total = data.total;
          this.courseList = data.data;
        });
      }
    },
    changePage(val) {
      this.page = val;
      this.getList();
    }
  },
  components: {
    Course
  }
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
